
import React from "react";
import FeedbackForm from "../Comms/FeedbackForm";
import Header from "../Header/Header";
import SaverCreditAccordion from "./SaverCreditAccordion"
import Form8880 from "./Form8880";
import FormSchedule3 from "./FormSchedule3";
import FormExample1 from "./FormExample1";
import Form1040 from "./Form1040";
import SaversCreditStory1 from "../Jordan/SaversCreditStory1";
import SaversCreditSteps from "../Jordan/SaversCreditSteps";
import SaverCreditTwoUp from "../AMain/SaverCreditTwoUp";
import Form1040Flow from "../TryAgain/Form1040Flow";

export default function Savers() {

  return (<div>

    <div className="page-wrapper">
      <div className="page-root">
        <div className="page-container"><Header />
 
  
          <SaverCreditAccordion />


  </div></div> 
       <FeedbackForm
                title="GILDARC"
                text="If you have any notes or comment, please utilize the following."
                collectionName="Page1Comments"          // current collection
                source="Savers"
            />
  </div></div>
  );
};
